module.exports = __webpack_public_path__ + "assets/img/bp_d_i_9.0ee2f327.jpg";